// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.checkbox-small-button {
  border-radius: 5px;
  background: white;
  border: 2px solid #0669B3;
  color: #0669B3;
  font-weight: 550;
  padding: 10px;
  width: 220px;
}
.checkbox-small-button label {
  display: flex;
  align-items: center;
}
.checkbox-small-button label input[type=checkbox] {
  width: 20px;
  height: 20px;
  margin-right: 10px;
  cursor: pointer;
}

.checked {
  background: #0669B3;
  color: white;
}
.checked input[type=checkbox] {
  width: 20px;
  height: 20px;
  background: #0669B3;
  margin-right: 10px;
}

.all-locations-checkbox {
  margin-bottom: 20px;
}
.all-locations-checkbox input[type=checkbox] {
  width: 20px;
  height: 20px;
  background: #0669B3;
  margin-right: 10px;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/CheckboxButton.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;ECAI,kBDCsB;EACtB,iBAAA;EACA,yBAAA;EACA,cDwBS;ECvBT,gBAAA;EACA,aAAA;EACA,YAAA;AAUJ;AARI;EACI,aAAA;EACA,mBAAA;AAUR;AATQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AAWZ;;AAPA;EACI,mBDOS;ECNT,YAAA;AAUJ;AATI;EACI,WAAA;EACA,YAAA;EACA,mBDEK;ECDL,kBAAA;AAWR;;AAPA;EACI,mBAAA;AAUJ;AATI;EACI,WAAA;EACA,YAAA;EACA,mBDRK;ECSL,kBAAA;AAWR","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n$lt-blue: #7DB7CC;\n$dk-blue: #19608f;\n$dashboard-blue: #0d6efd;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n// $DCSD-logo-green: #84ae30; // old - does not pass\n// $DCSD-logo-green: #94B741; // this is the color from district site (see kellys screen shot)\n$DCSD-logo-green: #577d00; // darker green but does pass in FF\n$text: #414042;\n$white: #EDEDED;\n$shadow: #818181;\n$shadow2: #525151;\n$red: #CB321A;\n$green: #C7CC68;\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$grey0: #EDf0F1;\n$grey0b: #e8e8e8; // new grey color\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$grey5: #333;\n$pale-blue: #C0DEF0;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n$accessibility-red: rgb(218, 18, 18);\n","@import \"./global/Colors.scss\";\n@import \"./global/globalMixins.scss\";\n\n.checkbox-small-button {\n    @include borderRadius(5px);\n    background: white;\n    border: 2px solid $pearl-blue;\n    color: $pearl-blue;\n    font-weight: 550;\n    padding: 10px;\n    width: 220px;\n\n    label {\n        display: flex;\n        align-items: center;\n        input[type=\"checkbox\"] {\n            width: 20px;\n            height: 20px;\n            margin-right: 10px;\n            cursor: pointer;\n        }\n    }\n}\n.checked {\n    background: $pearl-blue;\n    color: white;\n    input[type=\"checkbox\"] {\n        width: 20px;\n        height: 20px;\n        background: $pearl-blue;\n        margin-right: 10px;\n    }\n}\n\n.all-locations-checkbox {\n    margin-bottom: 20px;\n    input[type=\"checkbox\"] {\n        width: 20px;\n        height: 20px;\n        background: $pearl-blue;\n        margin-right: 10px;\n    }\n}\n","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
